export { GoogleClassroomLogo } from './GoogleClassroomLogo'
